import React from "react";
import UserAccessRoleMenu from "../components/menu/admin/UserAccessRoleMenu";

const ManajemenRolePengguna = () => {
  return <UserAccessRoleMenu />;
};
export default ManajemenRolePengguna;
